import { FooterStyled } from "./styled";

const Footer = () => {
  return (
    <FooterStyled>
      <p>
        &copy; 2023 Todos os direitos reservados | Desenvolvido por Luan
        Christian
      </p>
    </FooterStyled>
  );
};

export default Footer;
